import React from "react";
import { useTab } from "../../contexts/tab";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";

const tabList = ["Label Size", "Core", "Paper", "Paper Size", "Color", "Ups"];

export default function TabNav() {
  const [{ activeTab }, { setActiveTab, setTabData }] = useTab();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className=" bg-gray-200 mb-4">
      {tabList.map((text, i) => {
        return (
          <button
            key={i}
            onClick={() => {
              setSearchParams({
                tab: i,
              });
              setActiveTab(i);
              if (activeTab != i) setTabData(null);
            }}
            className={classNames(
              "border px-4 py-2 bg-gray-200",
              i === activeTab && "bg-white"
            )}
          >
            {text}
          </button>
        );
      })}
    </div>
  );
}
